import React, { useEffect, useState } from "react";
import { Button, Spinner, Table, Tabs } from "@heroui/react";
import { LoadingState } from "../components/LoadingState";
import { PortalPanel } from "../components/PortalPanel";
import { useLocale } from "../context/LocaleContext";
import { apiFetch } from "../lib/apiClient";

export function ExportsPage() {
  const { t } = useLocale();
  const [loading, setLoading] = useState(true);
  const [exports, setExports] = useState([]);
  const [activeTab, setActiveTab] = useState("history");

  const load = () => {
    setLoading(true);
    apiFetch("/api/case_exports")
      .then((data) => setExports(data.case_exports || []))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="portal-withdrawals-layout">
      <Tabs
        selectedKey={activeTab}
        onSelectionChange={(key) => setActiveTab(String(key))}
        orientation="vertical"
        className="portal-status-tabs w-full max-w-[220px]"
      >
        <Tabs.ListContainer>
          <Tabs.List
            aria-label={t("exports.pageTitle") || "Exports"}
            className="portal-status-tabs__list w-full *:w-full *:justify-start *:px-3 *:py-2 *:text-sm *:font-medium *:data-[selected=true]:text-accent-foreground"
          >
            <Tabs.Tab id="history">
              {t("exports.historyTitle") || "Export history"}
              <Tabs.Indicator className="bg-accent" />
            </Tabs.Tab>
          </Tabs.List>
        </Tabs.ListContainer>
      </Tabs>

      <div className="portal-withdrawals-layout__content">
        <PortalPanel className="portal-data-grid">
          <div className="portal-data-grid__toolbar">
            <div className="portal-data-grid__title-row">
              <h2 className="portal-panel__title">{t("exports.pageTitle") || "Exports and reports"}</h2>
              <span className="portal-data-grid__count">{exports.length}</span>
            </div>
            <Button variant="secondary" onPress={load}>
              {t("common.refresh") || "Refresh"}
            </Button>
          </div>

          <div className="portal-data-grid__table-wrap">
            {loading ? (
              <div className="portal-data-grid__loading">
                <Spinner size="md" />
                <span>{t("common.loading")}</span>
              </div>
            ) : (
              <Table variant="secondary" className="portal-data-grid__table">
                <Table.ScrollContainer>
                  <Table.Content aria-label={t("exports.pageTitle") || "Exports"}>
                    <Table.Header>
                      <Table.Column>ID</Table.Column>
                      <Table.Column>{t("exports.status") || "Status"}</Table.Column>
                      <Table.Column>{t("exports.type") || "Type"}</Table.Column>
                      <Table.Column>{t("exports.created") || "Created"}</Table.Column>
                    </Table.Header>
                    <Table.Body
                      items={exports}
                      renderEmptyState={() => (
                        <div className="portal-data-grid__empty">
                          <p className="portal-data-grid__empty-title">{t("exports.empty") || "No exports yet."}</p>
                        </div>
                      )}
                    >
                      {(row) => (
                        <Table.Row id={String(row.id)}>
                          <Table.Cell>{row.id}</Table.Cell>
                          <Table.Cell>{row.status}</Table.Cell>
                          <Table.Cell>{row.export_type}</Table.Cell>
                          <Table.Cell>{row.created_at}</Table.Cell>
                        </Table.Row>
                      )}
                    </Table.Body>
                  </Table.Content>
                </Table.ScrollContainer>
              </Table>
            )}
          </div>
        </PortalPanel>
      </div>
    </div>
  );
}
